import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { CheckoutPaymentTypeComponent } from '@spartacus/checkout/b2b/components'
import { B2BPaymentTypeEnum, CheckoutPaymentTypeFacade } from '@spartacus/checkout/b2b/root'
import { CheckoutStepService } from '@spartacus/checkout/base/components'
import { GlobalMessageService } from '@spartacus/core'
import { map } from 'rxjs'
import { SharedService } from '../../../services/shared/shared.service'

@Component({
  selector: 'app-custom-payment-type',
  templateUrl: './custom-payment-type.component.html',
  styleUrls: ['./custom-payment-type.component.scss'],
  standalone: false
})
export class CustomPaymentTypeComponent extends CheckoutPaymentTypeComponent implements OnInit {
  constructor(
    protected checkoutPaymentTypeFacade: CheckoutPaymentTypeFacade,
    protected checkoutStepService: CheckoutStepService,
    protected activatedRoute: ActivatedRoute,
    protected sharedService: SharedService,
    protected globalMessageService: GlobalMessageService
  ) {
    super(checkoutPaymentTypeFacade, checkoutStepService, activatedRoute, globalMessageService)
  }

  ngOnInit(): void {
    this.paymentTypes$.pipe(
      map((paymentTypes) => paymentTypes.find((payment) => payment.code === B2BPaymentTypeEnum.ACCOUNT_PAYMENT))
    )
  }
}
